content-image {
  display: block;
  height: auto;
  transition: opacity .3s;
  position: relative;
  &.content-image-loading {
    opacity: 0;
  }
  &.content-image-loaded {
    opacity: 1;
  }

  &[aspect-ratio] {
    img, picture, video {
      aspect-ratio: var(--aspect-ratio);
      object-fit: cover;
    }
  }
  img,
  picture,
  video {
    display: block;
    width: 100%;
    height: 100%;
  }

  .content-image__media-content {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    [slot="mediaContent"] {
      height: 100%;
      width: 100%;
    }
  }
  &[content="true"] .content-image__media-content {
    display: flex;
  }
}
